// announcement.ts

// 指定された要素にフォーム送信と新しいウィンドウでリンクを開く機能を追加
function handleAnnouncementClick(event: MouseEvent) {
  event.preventDefault(); // デフォルトのクリック動作を無効化

  const target = event.currentTarget as HTMLElement;
  const form = target.closest("form") as HTMLFormElement;

  if (form) {
    form.submit(); // フォームを送信
  }

  const link = target.getAttribute("data-url");
  if (link) {
    window.open(link, "_blank"); // 新しいタブでリンクを開く
  }
}

// 全ての announcement アイテムにイベントリスナーを追加
export function initializeAnnouncementListeners(): void {
  const announcementLinks = document.querySelectorAll<HTMLAnchorElement>(".announcement-link");

  announcementLinks.forEach((link) => {
    link.addEventListener("click", (event: MouseEvent) => handleAnnouncementClick(event));
  });
}
